// extracted by mini-css-extract-plugin
export var active = "_1z-9";
export var backButton = "_1z-8";
export var clone = "_1z-e";
export var collapseBar = "_1z-k";
export var collapseMode = "_1z-m";
export var collapsed = "_1z-o";
export var dimmed = "_1z-i";
export var dragHandle = "_1z-c";
export var dropdownIcon = "_1z-g";
export var expanding = "_1z-n";
export var hidden = "_1z-x";
export var iconContainer = "_1z-q";
export var iconSwapper = "_1z-w";
export var navItem = "_1z-6";
export var navItemIcon = "_1z-f";
export var navProfile = "_1z-7";
export var notificationCountBadge = "_1z-j";
export var notificationDot = "_1z-r";
export var optionsContainer = "_1z-h";
export var primaryNav = "_1z-0";
export var primaryNavDivider = "_1z-v";
export var primaryNavResizeHandle = "_1z-2";
export var primaryNavResizing = "_1z-1";
export var primaryNavTabSection = "_1z-u";
export var primaryTab = "_1z-p";
export var primaryTabIconBox = "_1z-s";
export var secondaryNav = "_1z-3";
export var selected = "_1z-t";
export var settingsNav = "_1z-4";
export var settingsNavItems = "_1z-5";
export var show = "_1z-d";
export var sideNav = "_1z-l";
export var teamItem = "_1z-a";
export var userProfileItem = "_1z-b";